"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartStatusEnum = exports.CartStateEnum = void 0;
var CartStateEnum;
(function (CartStateEnum) {
    CartStateEnum["ACTIVE"] = "active";
    CartStateEnum["CANCELED"] = "canceled";
    CartStateEnum["CLEARED"] = "cleared";
    CartStateEnum["INVOICED"] = "invoiced";
})(CartStateEnum = exports.CartStateEnum || (exports.CartStateEnum = {}));
var CartStatusEnum;
(function (CartStatusEnum) {
    CartStatusEnum["VALID"] = "valid";
    CartStatusEnum["INVALID"] = "invalid";
    CartStatusEnum["UNKNOWN"] = "unknown";
    CartStatusEnum["PROCESSING"] = "processing";
})(CartStatusEnum = exports.CartStatusEnum || (exports.CartStatusEnum = {}));
//# sourceMappingURL=cart.enums.js.map